import { SubmitHandler } from "react-hook-form";
import { Toast } from "@sscs/ui";
import { Member } from "Types";
import { apiErrorToast } from "Utils";
import useCurrentOrganizationData from "../../hooks/useCurrentOrganizationData";
import { useUpdateUserAndGroupsMutation } from "../../services/users.api";
import { MemberFormData } from "../../types";
import useEditForm from "./useEditForm";

const useEditMember = (initialValues: Member, onDone: () => void) => {
  const currentOrganizationData = useCurrentOrganizationData();
  const [updateUserAndGroups] = useUpdateUserAndGroupsMutation();
  const form = useEditForm(initialValues);
  const { handleSubmit } = form;
  const isFormEdited = form.formState.isDirty;

  const onSubmit: SubmitHandler<MemberFormData> = async (data) => {
    if (!currentOrganizationData || !isFormEdited) {
      onDone();
      return;
    }

    try {
      await updateUserAndGroups({
        userId: initialValues.user_id,
        body: {
          email: data.email,
          org_role: data.orgRole,
          group_ids: data.orgGroups,
        },
      }).unwrap();
    } catch (error) {
      apiErrorToast(error, "Could not edit member information");
      return;
    } finally {
      onDone();
    }

    Toast.show({
      title: "Edited member information",
      type: "success",
    });
  };

  return {
    form,
    groups: currentOrganizationData?.groups || [],
    onSubmit: handleSubmit(onSubmit),
  };
};

export default useEditMember;
